module.exports = __webpack_public_path__ + "static/media/13-speaker_profile.63564400.webp";